var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHappyTripAdvisor = function SvgHappyTripAdvisor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "inherit",
    height: "inherit",
    fill: "none",
    viewBox: "0 0 26 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    d: "M9.24 11.262a2.21 2.21 0 1 1-4.419 0 2.21 2.21 0 0 1 4.418 0m10.243-2.209a2.21 2.21 0 1 0-.003 4.417 2.21 2.21 0 0 0 .004-4.416zm6.228 2.21a6.228 6.228 0 0 1-10.458 4.568l-1.994 2.17-1.994-2.173a6.227 6.227 0 1 1-8.426-9.167L.8 4.445h4.527a14.11 14.11 0 0 1 15.874 0h4.515L23.68 6.66a6.2 6.2 0 0 1 2.032 4.601m-14.466 0a4.213 4.213 0 1 0-8.427 0 4.213 4.213 0 0 0 8.427 0m6.69-6.29a12.16 12.16 0 0 0-9.352 0c2.66 1.017 4.676 3.395 4.676 6.168 0-2.772 2.016-5.15 4.676-6.169m5.762 6.29a4.213 4.213 0 1 0-8.427 0 4.213 4.213 0 0 0 8.427 0"
  })));
};
export default SvgHappyTripAdvisor;